import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Invoke}         from "@Common/react/invoke";
import {buildUrlQuery}  from "@Common/utils/build-url-query";
import {parseUrlQuery}  from "@Common/utils/parse-url-query";

import {UserAssetsLayout} from "./common/layout/user-assets-layout";

export const UserAssetsRedirectRoute = () => cs(
    ({}, next) => UserAssetsLayout({activeTab: null, next}),
    consumeContext("routerHistory"),
    ["query", ({}, next) => next(parseUrlQuery(window.location.search))],
    ["agentId", ({query}, next) => next(query?.agent)],
    ["branchId", ({query}, next) => next(query?.branch)],
    ({agentId, branchId, routerHistory}) => (
        Invoke({
            action: () => {
                routerHistory.replace(
                    "/account/admin/user/headshots"
                    + buildUrlQuery({
                        agent: agentId,
                        branch: branchId,
                    })
                );
            },
        })
    ),
);
